export enum RequestStatusKindEnum {
    pending = 1,
    working = 2,
    final = 3
}